import { BanknotesIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const LateFineRulesFeature: FeatureMetadata = {
  id: "late-fine-rules",
  moduleName: "feesFinance",
  navigation: {
    label: "Late Fine Rules",
    path: "/late-fine-rules",
    icon: BanknotesIcon,
    order: 4,
  },
  route: {
    path: "/late-fine-rules",
    element: lazy(() => import("./pages/LateFineRules")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FineRules", {
    view: permissionId("FeeFinance", "FineRules", "view"),
    create: permissionId("FeeFinance", "FineRules", "edit"),
    edit: permissionId("FeeFinance", "FineRules", "edit"),
    delete: permissionId("FeeFinance", "FineRules", "edit"),
  }),
  readiness: "live",
};
